type UnsubscribeType = () => void;
type CallbackType = () => void;

type IdType = {};

class Idle {
    private readonly request: Set<IdType>;
    private callback: Map<IdType, CallbackType>;

    public constructor() {
        this.request = new Set();
        this.callback = new Map();
    }

    private refresh = (): void => {
        if (this.request.size === 0) {
            const callback = this.callback;
            this.callback = new Map();
            for (const callbackItem of callback.values()) {
                callbackItem();
            }
        }
    };

    public registerNetworRequest = (): UnsubscribeType => {
        const id: IdType = {};

        this.request.add(id);

        return (): void => {
            this.request.delete(id);
            this.refresh();
        };
    };

    public whenIdle = (callback: CallbackType): UnsubscribeType => {
        const id: IdType = {};
        this.callback.set(id, callback);

        this.refresh();

        return () => {
            this.callback.delete(id);
        };
    };
}

export const idle = new Idle();

export const registerNetworRequest = idle.registerNetworRequest;

export const whenIdle = idle.whenIdle;
